var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NodeViewWrapper',{attrs:{"as":"span"}},[_c('span',{class:_vm.node.type.name,attrs:{"data-id":_vm.node.attrs['data-id']}},[_vm._v("-- choose --")])])
}
var staticRenderFns = []

export { render, staticRenderFns }